import DeadlineCalendarModal from 'Components/campaigns/collaborations/milestone/components/DeadlineCalendar';
import FeedbackModal from 'Components/campaigns/collaborations/milestone/components/Feedback';
import FormBuilderModal from 'Components/campaigns/collaborations/milestone/FormBuilder';
import GigSelectionModal from 'Components/campaigns/collaborations/milestone/GigSelection';
import CollaborationContent from 'Components/campaigns/collaborations/milestone/tabs/CollaborationContent';
import Specifications from 'Components/campaigns/collaborations/milestone/tabs/Specifications';
import Timeline from 'Components/campaigns/collaborations/milestone/tabs/Timeline';
import CollaborationLayout from 'Layouts/CollaborationLayout/CollaborationLayout'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { fetchCollaborationChatRoom, fetchCollaborationMilestoneData } from 'slices/campaigns/collaborations/milestones/thunk';
import { fetchCollaboration } from 'slices/campaigns/collaborations/thunk';
import { AppDispatch, RootState, store } from 'store';
import { MilestoneStep, MilestoneEvent, Gig, Milestone } from 'types/campaign/collaborations';
import { getMediaTypeFromURL } from 'utils/helpers';
import "./collaboration.scss";
import { DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import InfluencerPostModal from 'Components/influencer/InfluencerPostModal';
import { fetchPermalinkFile } from 'slices/files/reducer';
import CloseButton from 'Components/Common/CloseButton';
import withAccessControl from 'hoc/withAccessControl';
import { PRIVILEGE } from 'constants/privilege';
import { useIdleTimer } from 'react-idle-timer';
import Loader from 'Components/Common/Loader';
import userDummayImage from "../../../../assets/images/users/user-dummy-img.jpg"
import SimpleBar from 'simplebar-react';
import { resetTasksSummary } from 'slices/campaigns/collaborations/milestones/reducer';
import { toast } from 'react-toastify';
import CollaborationChat from 'Components/campaigns/collaborations/chat/CollaborationChat';
import { useMediaQuery } from 'hooks/useMediaQuery';

const Collaboration = () => {

    const { campaignId, influencerId, milestoneId } = useParams();
    const [searchParams] = useSearchParams();
    const filtersQuery = searchParams.get('filters');

    const tabsRef = useRef<HTMLDivElement | null>(null);

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const { isDesktop } = useMediaQuery();

    // Redux Data //
    const influencerPostModalVisibile = useSelector((state: RootState) => state.ui.influencerPostModal);
    const milestoneData = useSelector((state: RootState) => state.collaborationMilestones.collaborations[campaignId!]?.[influencerId!]?.[milestoneId!]?.data);
    const activeMilestone = milestoneData?.milestone ?? null;
    const gigs = milestoneData?.gigs ?? [];

    const collaborationData = useSelector((state: RootState) => state.collaborations.campaigns[campaignId!]?.collaborations?.[influencerId!]);

    const collabLoading = useSelector((state: RootState) => state.collaborations.collaborationLoading);

    const collaboration = collaborationData?.collaboration ?? null;
    const milestones = collaborationData?.milestones ?? [];
    const campaign = collaboration?.campaign;
    const posts = milestoneId ? (milestoneData?.posts ?? []) : (collaboration?.posts ?? []);
    const acknowledged = activeMilestone?.acknowledged_at ?? false;
    const [currentTasks, setCurrentTasks] = useState<MilestoneStep[]>([]);
    const [events, setEvents] = useState<MilestoneEvent[]>([]);
    const permalinkFiles = useSelector((state: RootState) => state.permalinkFiles.files);
    const chatRoom = useSelector((state: RootState) => state.collaborationMilestones.chatRooms[campaignId!]?.[influencerId!]?.room);
    const chatRoomId = collaborationData?.chat?.uuid ?? (chatRoom?.uuid ?? null);
    // Redux Data //

    // Local States //
    const [openedStep, setOpenedStep] = useState<string | null>(null);
    const [selectedMedia, setSelectedMedia] = useState<any>(null);
    const [activeTab, setActiveTab] = useState('timeline');
    const [isDownloading, setIsDownloading] = useState(false);
    const [showDisabledTooltip, setShowDisabledTooltip] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [deadlineCalendarStep, setDeadlineCalendarStep] = useState<MilestoneStep | null>(null);
    const [loading, setLoading] = useState(false);
    const [chatSectionVisibility, setChatSectionVisibility] = useState(false);
    // Local States //


    // Refs //

    const collabSectionRef = useRef<any>(null);
    const chatSectionRef = useRef<any>(null);

    // Refs //

    // Functions //    

    const getMilestoneName = (milestone: Milestone) => {
        return `${milestones.length > 1 ? `#${milestone?.sort_order} ` : ''}${milestone?.gig_type?.name}`
    }

    const fetchCollaborationData = useCallback(async (force = false) => {
        if (campaignId && influencerId)
            await dispatch(fetchCollaboration({ campaignId, collaborationId: influencerId, force }))
    }, [dispatch, campaignId, influencerId])

    const fetchCollaborationMilestones = useCallback(async (force = false) => {
        if (campaignId && milestoneId && influencerId)
            await dispatch(fetchCollaborationMilestoneData({ campaignId, milestoneId, influencerId, force }))
    }, [dispatch, campaignId, milestoneId, influencerId])

    const onPlayButtonClick = async (gig: Gig) => {
        const agencyId = store.getState().auth.selectedAgencyId;
        if (!campaignId || !agencyId || !influencerId) return;
        try {
            const result = await dispatch(
                fetchPermalinkFile({ campaignId, agencyId, influencerId, permalink: gig.properties.permalink })
            ).unwrap();

            setSelectedMedia({ ...result.file, gig });
        } catch (error) {
            window.open(gig.properties.permalink, '_blank');
            console.log(error);
        }
    }

    const handleDownload = async (gig: Gig) => {
        if (!campaignId) return;

        try {
            // setIsDownloading(true);
            // const blob = await fetchCollaborationPermalinkFile(
            //     campaignId,
            //     gig.properties.permalink,
            //     'download'
            // );

            // const blobUrl = window.URL.createObjectURL(blob);
            // const link = document.createElement('a');
            // link.href = blobUrl;
            // link.setAttribute('download', `${gig.name}.mp4`);
            // document.body.appendChild(link);
            // link.click();
            // link.remove();
            // window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
        } finally {
            setIsDownloading(false);
        }
    };
    // Functions //

    // Memoized Data //
    const tabs = useMemo(() => {
        return [
            // { key: 'current', label: 'Current Task' },
            { key: 'timeline', label: 'Timeline' },
            ...(milestoneId ? [{ key: 'specs', label: 'Brief' }] : []),
            { key: 'content', label: 'Content' }
        ]
    }, [acknowledged, milestoneId])

    const getCurrentStepsComponents = useMemo(() => {
        let components: React.ReactNode[] = [];
        if (!activeMilestone) return components;

        const onCloseHandler = (refetch?: boolean) => {
            setOpenedStep(null)
            if (refetch) {
                fetchCollaborationMilestones(true);
                dispatch(resetTasksSummary());
            }
        }

        for (let task of currentTasks) {
            if (task.gig_step.slug === 'gig_selection') {
                components.push(
                    <GigSelectionModal
                        isActive={openedStep === 'gig_selection'}
                        onClose={onCloseHandler}
                        activeMilestone={activeMilestone}
                        gigs={gigs}
                        onPlayButtonClick={onPlayButtonClick}
                        handleDownload={handleDownload}
                        step={task}
                    />
                )
            } else if (task.gig_step.slug === 'address_submission') {
                components.push(
                    // <AddressSelectionModal
                    //     isActive={openedStep === 'address_submission'}
                    //     onClose={onCloseHandler}
                    //     activeMilestone={activeMilestone}
                    //     step={task}
                    // />
                )
            } else if (['post_selection', 'reel_selection', 'story_selection'].includes(task.gig_step.slug)) {
                components.push(
                    // <PostSelectionModal
                    //     isActive={openedStep === task.gig_step.slug}
                    //     onClose={onCloseHandler}
                    //     activeMilestone={activeMilestone}
                    //     gigs={gigs}
                    //     setSelectedMedia={(post: any) => setSelectedMedia(post)}
                    //     step={task}
                    // />
                )
            } else {
                components.push(
                    <FormBuilderModal
                        isActive={openedStep === task.gig_step.slug}
                        onClose={onCloseHandler}
                        title={task.gig_step.title ?? task.gig_step.name}
                        activeMilestone={activeMilestone}
                        step={task}
                    />
                )
            }
        }
        return components;
    }, [currentTasks, activeMilestone, gigs, openedStep])

    // Memoized Data //

    // Lifecycle Methods //

    useEffect(() => {
        if (!milestoneId) {
            setActiveTab('timeline');
        }
    }, [milestoneId])

    useEffect(() => {
        setActiveTab('timeline');
    }, [influencerId, campaignId, milestoneId])

    useEffect(() => {
        tabsRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [activeTab])

    useEffect(() => {
        if (!milestoneId && campaignId && influencerId && milestones.length > 0) {
            const _milestones = [...milestones].sort((a, b) => b.sort_order - a.sort_order);
            navigate(`/collaboration/campaign/${campaignId}/collaboration/${influencerId}/milestone/${_milestones[0].id}`);
        }
    }, [milestoneId, milestones, campaignId, influencerId])

    useEffect(() => {
        if (!milestoneData && !milestoneId && collaboration) {

            const pendingPost = (collaboration?.posts ?? []).find((post) => post.status === 'pending');

            const step: MilestoneStep = {
                sort_order: 1,
                is_locked: false,
                is_processed: true,
                processed: null,
                deliverables: {
                },
                can_process: false,
                gig_step: {
                    slug: 'ig_media_approval',
                    name: "Instagram Media Approval*",
                    title: pendingPost ? "Please approve the live instagram media" : "Instagram media has been approved",
                    description: "Influencer has uploaded live media",
                    cta_text: "",
                    revision_required_title: "",
                    processed_title: "",
                    object_name: "",
                    properties: [],
                    attributes: {},
                    require_deadline: false,
                },
                deadline: null,
                complete: !pendingPost
            }
            setCurrentTasks([step]);
            setEvents([]);
            return;
        }
        if (Array.isArray(milestoneData?.active_steps)) {
            let steps = [...milestoneData?.active_steps].sort((a, b) => a.sort_order - b.sort_order);
            setCurrentTasks(steps);
        }
        if (Array.isArray(milestoneData?.events)) {
            let timelineEvents = [...milestoneData?.events].sort((a, b) => (new Date(a.created_at)).getTime() - (new Date(b.created_at)).getTime());
            setEvents(timelineEvents);
        }
    }, [milestoneData, milestoneId, collaboration])

    useEffect(() => {
        if (campaignId) {
            fetchCollaborationData();
        }
    }, [campaignId, fetchCollaborationData])

    useEffect(() => {
        if (campaignId) {
            fetchCollaborationMilestones();
        }
    }, [campaignId, milestoneId, fetchCollaborationMilestones])

    useEffect(() => {
        const hideDisabledTooltip = () => {
            setShowDisabledTooltip(false);
        }

        if (showDisabledTooltip) {
            setTimeout(() => {
                hideDisabledTooltip()
            }, 3000)
            document.addEventListener('scroll', hideDisabledTooltip);
        }

        return () => {
            document.removeEventListener('scroll', hideDisabledTooltip);
        }
    }, [showDisabledTooltip])

    // Lifecycle Methods //

    useIdleTimer({
        timeout: 1000 * 60 * 5, // 5 minutes
        onActive: () => {
            fetchCollaborationMilestones(true)
            fetchCollaborationData(true);
        },
        throttle: 1000,
    });

    const forceRefetch = async () => {
        setLoading(true);
        await fetchCollaborationMilestones(true);
        await fetchCollaborationData(true);
        setLoading(false);
    }

    const [creatingChatRoom, setCreatingChatRoom] = useState(false);

    const createChatRoom = async () => {
        if (creatingChatRoom || !campaignId || !influencerId) return;
        setCreatingChatRoom(true);
        try {
            await dispatch(fetchCollaborationChatRoom({ campaignId, influencerId }))
        } catch (error: any) {
            toast.error("Failed to open chat room, Please try again later!");
        } finally {
            setCreatingChatRoom(false);
        }
    }

    useEffect(() => {
        if (!isDesktop) {
            console.log(collabSectionRef.current, chatSectionRef.current, chatSectionVisibility);
            if (chatSectionVisibility) {
                if (collabSectionRef?.current) {
                    collabSectionRef.current.style.display = 'none';
                }
                if (chatSectionRef?.current) {
                    chatSectionRef.current.style.display = 'block';
                }
            } else {
                if (collabSectionRef?.current) {
                    collabSectionRef.current.style.display = 'block';
                }
                if (chatSectionRef?.current) {
                    chatSectionRef.current.style.display = 'none';
                }
            }
        }
    }, [isDesktop, chatSectionVisibility])


    if (loading) return <Loader />


    return (
        <CollaborationLayout>
            {
                !influencerId &&
                <div className="d-flex h-100 w-100 justify-content-center align-items-center">
                    <div className="length-zero m-0">
                        <h3>No Collaboration Selected!</h3>
                    </div>
                </div>
            }
            {
                influencerId &&
                <div className="chat-content d-lg-flex">
                    <div className="w-100 overflow-hidden position-relative">
                        <div className="p-3 user-chat-topbar z-3">
                            <div className="d-flex justify-content-between gap-2 align-items-center">
                                <div className="d-flex align-items-center w-50">
                                    <div className="flex-shrink-0 d-block d-lg-none me-1">
                                        <Link to={{ pathname: "/collaboration", search: filtersQuery ? `?filters=${filtersQuery}` : '' }} className="user-chat-remove fs-18 p-1"                              >
                                            <i className="ri-arrow-left-s-line align-bottom"></i>
                                        </Link>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0 chat-user-img online user-own-img align-self-center me-2 ms-0">
                                                {collaboration?.influencer?.social_account?.profile_picture_url ? (
                                                    <img src={collaboration.influencer.social_account?.profile_picture_url} className="rounded-circle avatar-xs" alt="" />
                                                ) : (
                                                    <img src={userDummayImage} className="rounded-circle avatar-xs" alt="" />
                                                )}
                                            </div>
                                            <div className="overflow-hidden">
                                                <h5 className="text-truncate w-100 mb-0 fs-16">
                                                    <a
                                                        className="text-reset collaborator-name username"
                                                        data-bs-toggle="offcanvas"
                                                        href="#userProfileCanvasExample"
                                                        aria-controls="userProfileCanvasExample"
                                                    >
                                                        <span>
                                                            {
                                                                collaboration?.influencer?.name}
                                                            {/* <button onClick={createChatRoom} disabled={creatingChatRoom} className='btn h-auto w-auto px-1 btn-icon text-primary fs-5'><i className='bx bxs-chat'></i></button> */}
                                                        </span>
                                                        <p className="text-muted w-100 text-truncate collaboration-campaign-name fs-12 mb-0">{campaign?.name}</p>
                                                    </a>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-100 d-flex justify-content-end align-items-center gap-2'>
                                    {
                                        activeMilestone &&
                                        <UncontrolledDropdown className='milestone-dropdown'>
                                            <DropdownToggle tag={"button"} className={`${milestones.length > 1 ? 'milestone-dropdown-btn' : ''} btn btn-white d-flex justify-content-between align-items-center w-100`}>
                                                <span className='text-truncate milestone-name-dropdown-text'>
                                                    {getMilestoneName(activeMilestone)}
                                                </span>
                                                {
                                                    milestones.length > 1 &&
                                                    <i className='mdi mdi-chevron-down text-007AFF fs-5' />
                                                }
                                            </DropdownToggle>
                                            {
                                                milestones.length > 1 &&
                                                <DropdownMenu className='mt-1 p-0 w-100'>
                                                    {
                                                        milestones.map((_milestone, i) => <DropdownItem onClick={() => navigate(`/collaboration/campaign/${campaignId}/collaboration/${influencerId}/milestone/${_milestone.id}${filtersQuery ? '?filters=' + filtersQuery : ''}`)} key={i}>{getMilestoneName(_milestone)}</DropdownItem>)
                                                    }
                                                </DropdownMenu>
                                            }
                                        </UncontrolledDropdown>
                                    }
                                    {
                                        !isDesktop &&
                                        <span onClick={() => setChatSectionVisibility(!chatSectionVisibility)} title='Chat' className='cursor-pointer d-flex align-items-center'><i className='fs-4 mdi mdi-chat-processing-outline text-primary'></i></span>
                                    }
                                    <span onClick={() => forceRefetch()} title='Refresh' className='cursor-pointer d-flex align-items-center'><i className='fs-4 bx bx-refresh text-primary' ></i></span>
                                </div>
                            </div>
                        </div>
                        <div className="position-relative" id="users-chat">
                            <div className="chat-conversation simplebar-scrollable-y d-flex" id="chat-conversation">
                                <div className={`${isDesktop ? 'w-50' : 'w-100'}`} ref={collabSectionRef}>
                                    <SimpleBar style={{ height: "100%" }}>
                                        <div className={`tab-controls milestone-tab-controls`} ref={tabsRef}>
                                            {tabs.map(tab => (
                                                <a
                                                    key={tab.key}
                                                    onClick={() => {
                                                        setActiveTab(tab.key)
                                                    }}
                                                    className={`milestone-tab d-flex align-items-center cursor-pointer justify-content-center gap-2 ${activeTab === tab.key ? 'active-tab' : ''}`}
                                                >
                                                    {tab.label}
                                                </a>
                                            ))}
                                        </div>
                                        <div className="milestone-tab-content">
                                            <div className={`collapse ${activeTab === 'timeline' && 'show'}`}>
                                                {
                                                    // activeMilestone &&
                                                    <Timeline
                                                        onFeedbackView={(fb) => setFeedback(fb)}
                                                        active_steps={currentTasks}
                                                        events={events}
                                                        setOpenedStep={setOpenedStep}
                                                        milestone={activeMilestone}
                                                        addDeadline={(step) => setDeadlineCalendarStep(step)}
                                                        onPlayBtnClick={onPlayButtonClick}
                                                        setSelectedMedia={setSelectedMedia}
                                                        onStepProcess={() => fetchCollaborationMilestones(true)}
                                                        refetchCollaboration={() => fetchCollaborationMilestones(true)}
                                                    />
                                                }

                                            </div>
                                            <div className={`collapse ${activeTab === 'specs' && 'show'}`}>
                                                {
                                                    activeMilestone && campaign &&
                                                    <Specifications
                                                        campaign={campaign}
                                                        activeMilestone={activeMilestone}
                                                        acknowledgementRequired={false}
                                                        onAcknowledgement={() => fetchCollaborationMilestones(true)}
                                                        showDisabledTooltip={showDisabledTooltip}
                                                        setSelectedMedia={setSelectedMedia}
                                                    />
                                                }
                                            </div>
                                            <div className={`collapse ${activeTab === 'content' && 'show'}`}>
                                                <CollaborationContent collaborationPosts={posts} />
                                            </div>
                                        </div>
                                        {
                                            getCurrentStepsComponents.map((component) => component)
                                        }
                                        <FeedbackModal
                                            isActive={!!feedback}
                                            onClose={() => setFeedback('')}
                                            feedback={feedback}
                                        />
                                        <DeadlineCalendarModal
                                            isActive={!!deadlineCalendarStep}
                                            onClose={(refetch) => {
                                                setDeadlineCalendarStep(null)
                                                if (refetch) {
                                                    fetchCollaborationMilestones(true);
                                                }
                                            }}
                                            step={deadlineCalendarStep!}
                                        />
                                        <InfluencerPostModal
                                            isOpen={!!influencerPostModalVisibile}
                                            onClose={(processed) => {
                                                if (processed) fetchCollaborationMilestones(true);
                                            }}
                                            postId={influencerPostModalVisibile?.postId!}
                                            collaborationId={collaboration?.uuid!}
                                            influencer={influencerPostModalVisibile?.influencer!}
                                            socialAccount={influencerPostModalVisibile?.socialAccount!}
                                            status={influencerPostModalVisibile?.status}
                                            milestoneStep={influencerPostModalVisibile?.milestoneStep}
                                            preventAction={!!influencerPostModalVisibile?.preventAction}
                                        />
                                        <Modal isOpen={!!selectedMedia} toggle={() => setSelectedMedia(null)}>
                                            <CloseButton top='0' onClose={() => setSelectedMedia(null)} />
                                            <ModalBody className='p-0 overflow-hidden' style={{ borderRadius: '6px', height: '75vh' }}>
                                                {
                                                    selectedMedia &&
                                                    <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                                                        {
                                                            getMediaTypeFromURL(selectedMedia.url) === 'video' &&
                                                            <video src={selectedMedia.url} autoPlay controls className='h-100 w-100 bgc-content' />
                                                        }
                                                        {
                                                            getMediaTypeFromURL(selectedMedia.url) === 'image' &&
                                                            <div className="h-100 w-100 bg-media bgc-content" style={{
                                                                backgroundImage: `url(${selectedMedia.url})`
                                                            }}></div>
                                                        }
                                                        <div className="media-action">
                                                            {
                                                                selectedMedia.gig &&
                                                                <span className='cursor-pointer text-white fs-5' onClick={() => handleDownload(selectedMedia.gig)}><i className="fa-solid fa-download"></i></span>
                                                            }
                                                            <span className='text-white fs-5' onClick={() => setSelectedMedia(null)}><i className="fa-solid fa-circle-xmark"></i></span>
                                                        </div>
                                                    </div>
                                                }
                                            </ModalBody>
                                        </Modal>
                                    </SimpleBar>
                                </div>

                                <div className={`${isDesktop ? 'w-50' : 'w-100'} collab-chat-section`} ref={chatSectionRef}>

                                    {
                                        chatRoomId ? (
                                            <CollaborationChat activeRoomId={chatRoomId} />
                                        ) : (
                                            <div className='h-100'>
                                                <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                                                    {
                                                        collabLoading ? (
                                                            <>
                                                                <Spinner />
                                                                <div>Loading Chat...</div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <h5 className='mb-3'>You can chat with creator</h5>
                                                                <button className='theme-btn theme-btn-md btn-gradient' disabled={creatingChatRoom} onClick={createChatRoom}>{creatingChatRoom ? 'Creating Chat Room...' : 'Start Chat'}</button>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            }

        </CollaborationLayout>
    )
}

export default withAccessControl(Collaboration, PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX)